// SPDX-License-Identifier: Apache-2.0
import GirafeHTMLElement from '../../../base/GirafeHTMLElement';

class NewsButtonComponent extends GirafeHTMLElement {
  templateUrl = './template.html';
  styleUrls = ['./style.css', '../../../styles/common.css'];

  visible: boolean = false;
  warn: boolean = false;

  constructor() {
    super('news-button');
  }

  setWarn() {
    this.warn = this.state.news.lastPublishDate > this.state.news.lastViewDate;

    if (this.context.configManager.Config.news?.autoDisplay && this.warn) {
      this.state.interface.newsPanelVisible = true;
    }

    super.render();
  }

  getIcon() {
    const icon = this.warn ? 'icons/bell-warn.svg' : 'icons/bell.svg';
    return icon;
  }

  override connectedCallback(): void {
    super.connectedCallback();
    if (this.context.configManager.Config.news) {
      this.subscribe('news.lastViewDate', (_oldValue: number, _newValue: number) => {
        this.setWarn();
      });
      this.subscribe('news.lastPublishDate', (_oldValue: number, _newValue: number) => {
        this.setWarn();
      });
      super.girafeTranslate();
    }
  }
}

export default NewsButtonComponent;
